<template>
    <v-data-table :headers="headers" :items="items" class="elevation-1">
        <!-- <template #item.capture="{ item }">
            <v-card width="80">
                <v-img cover :src="item.capture"></v-img>
            </v-card>
        </template> -->

        <template #item.threat="{ item }">
            <v-chip :color="getThreatColor(item.threat)" dark>{{ item.threat }}</v-chip>
        </template>

        <template #item.detectedObjects="{ item }">
            <div>
                <v-icon class="mr-2" v-for="object in item.detectedObjects" :key="object">{{ getObjectIcon(object)
                    }}</v-icon>
            </div>
        </template>

        <template #item.clips="{ item }">
            <v-btn small depressed color="primary" @click="playClip(item.id)">Open</v-btn>
        </template>
    </v-data-table>
</template>

<script>

const captureImg = require('./../assets/annotated_drone_flying.png')

export default {
    data() {
        return {
            headers: [
                { text: 'Time Range', value: 'timePeriod' },
                // { text: 'Capture', value: 'capture' },
                { text: 'Detections', value: 'detections' },
                { text: 'Intrusions', value: 'intrusions' },
                { text: 'Threat', value: 'threat' },
                { text: 'Summary', value: 'summary' },
                { text: 'Detected Objects', value: 'detectedObjects' },
                { text: 'Total Unique Objects', value: 'uniqueObjects' },
                { text: 'Clips', value: 'clips', sortable: false }
            ],
            items: [
                {
                    id: 1,
                    capture: captureImg, // sample image URL
                    detections: 25,
                    intrusions: 5,
                    threat: 'high',
                    summary: 'Multiple threats detected in area',
                    detectedObjects: ['persons', 'vehicles', 'drones'],
                    uniqueObjects: 8,
                    timePeriod: '00:00 - 0:59'
                },
                {
                    id: 2,
                    capture: captureImg,
                    detections: 15,
                    intrusions: 3,
                    threat: 'med',
                    summary: 'Potential threats under observation',
                    detectedObjects: ['vehicles', 'drones'],
                    uniqueObjects: 5,
                    timePeriod: '01:00 - 1:59'
                },
                {
                    id: 3,
                    capture: captureImg,
                    detections: 5,
                    intrusions: 1,
                    threat: 'low',
                    summary: 'Low activity, no significant threat',
                    detectedObjects: ['persons'],
                    uniqueObjects: 2,
                    timePeriod: '02:00 - 2:59',
                },
                {
                    id: 4,
                    capture: captureImg,
                    detections: 30,
                    intrusions: 8,
                    threat: 'high',
                    summary: 'High alert, immediate response needed',
                    detectedObjects: ['persons', 'vehicles', 'weapons'],
                    uniqueObjects: 10,
                    timePeriod: '03:00 - 3:59'
                },
                {
                    id: 5,
                    capture: captureImg,
                    detections: 10,
                    intrusions: 2,
                    threat: 'med',
                    summary: 'Moderate threat detected',
                    detectedObjects: ['vehicles'],
                    uniqueObjects: 4,
                    timePeriod: '04:00 - 4:59'
                },
                {
                    id: 6,
                    capture: captureImg, // sample image URL
                    detections: 18,
                    intrusions: 4,
                    threat: 'med',
                    summary: 'Moderate activity with potential risks',
                    detectedObjects: ['persons', 'vehicles'],
                    uniqueObjects: 6,
                    timePeriod: '05:00 - 5:59'
                },
                {
                    id: 7,
                    capture: captureImg,
                    detections: 45,
                    intrusions: 10,
                    threat: 'high',
                    summary: 'High threat level, immediate action required',
                    detectedObjects: ['persons', 'vehicles', 'weapons', 'drones'],
                    uniqueObjects: 12,
                    timePeriod: '06:00 - 6:59'
                },
                {
                    id: 8,
                    capture: captureImg,
                    detections: 10,
                    intrusions: 2,
                    threat: 'low',
                    summary: 'Minimal activity, low threat',
                    detectedObjects: ['persons'],
                    uniqueObjects: 3,
                    timePeriod: '07:00 - 7:59'
                },
                {
                    id: 9,
                    capture: captureImg,
                    detections: 22,
                    intrusions: 6,
                    threat: 'med',
                    summary: 'Significant movement detected',
                    detectedObjects: ['vehicles', 'drones'],
                    uniqueObjects: 7,
                    timePeriod: '08:00 - 8:59'
                },
                {
                    id: 10,
                    capture: captureImg,
                    detections: 50,
                    intrusions: 12,
                    threat: 'high',
                    summary: 'Numerous threats detected, high risk',
                    detectedObjects: ['persons', 'vehicles', 'weapons'],
                    uniqueObjects: 15,
                    timePeriod: '09:00 - 9:59'
                }

            ]
        };
    },
    methods: {
        getThreatColor(threat) {
            switch (threat) {
                case 'high': return 'red';
                case 'med': return 'orange';
                case 'low': return 'green';
                default: return 'grey';
            }
        },
        getObjectIcon(object) {
            switch (object) {
                case 'persons': return 'mdi-account';
                case 'vehicles': return 'mdi-car';
                case 'drones': return 'mdi-airplane';
                case 'weapons': return 'mdi-sword';
                default: return 'mdi-help';
            }
        },
        playClip(id) {
            console.log(`Playing clip for item with ID: ${id}`);
        }
    }
};
</script>

<style scoped>
.v-data-table th,
.v-data-table td {
    text-align: center;
}
</style>